'use client'

import { ColumnDef } from '@tanstack/react-table'
import { PoolData } from '@/views/V3Info/types'
import { CurrencyLogo } from '@pancakeswap/widgets-internal'
import { createCurrentcy } from '@/utils/currency'
import { Address } from 'viem'
import { Typography } from '@/components/ui/typography'
import React from 'react'
import { formatDollarAmount } from '@/views/V3Info/utils/numbers'
import SortButton from '@/components/sort-button'
import { Badge } from '@/components/ui/badge'
import { feeTierPercent } from '@/views/V3Info/utils'

export const poolColumns: ColumnDef<PoolData>[] = [
  {
    accessorKey: 'id',
    header: '#',
  },
  {
    id: 'pool',
    sortDescFirst: true,
    accessorFn: (row) => row.feeTier,
    header: ({ column }) => <SortButton<PoolData> name={'Pool'} column={column} />,
    cell: ({ row }) => {
      return (
        <div className={'flex items-center gap-2'}>
          <div className="flex items-center">
            <CurrencyLogo currency={createCurrentcy(999, row.original.token0.address as Address)} />
            <CurrencyLogo currency={createCurrentcy(999, row.original.token1.address as Address)} />
          </div>
          <Typography>
            {row.original.token0.symbol}/{row.original.token1.symbol}
          </Typography>
          <Badge variant={'secondary'}>{feeTierPercent(row.original.feeTier)}</Badge>
        </div>
      )
    },
  },
  {
    id: 'tvl',
    accessorFn: (row) => row.tvlUSD,
    sortDescFirst: true,
    cell: ({ row }) => {
      return formatDollarAmount(row.original.tvlUSD)
    },
    header: ({ column }) => <SortButton<PoolData> name={'TVL'} column={column} />,
  },
  {
    id: 'volume24h',
    accessorFn: (row) => row.volumeUSD,
    sortDescFirst: true,
    cell: ({ row }) => {
      return formatDollarAmount(row.original.volumeUSD)
    },
    header: ({ column }) => <SortButton<PoolData> name={'Volume 24H'} column={column} />,
  },
  {
    id: 'volume7d',
    accessorFn: (row) => row.volumeUSDWeek,
    sortDescFirst: true,
    cell: ({ row }) => {
      return formatDollarAmount(row.original.volumeUSDWeek)
    },
    header: ({ column }) => <SortButton<PoolData> name={'Volume 7D'} column={column} />,
  },
]
